import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { FormControlOptions, PolymorphicProps, StyleProps, SystemProps, ThemingProps } from './primitives.types';

export interface CheckboxProps extends
  SystemProps,
  PolymorphicProps,
  FormControlOptions,
  ThemingProps,
  Omit<React.ComponentPropsWithoutRef<'input'>, keyof StyleProps | keyof FormControlOptions | keyof ThemingProps | 'onChange' | 'onBlur' | 'onFocus' | 'value' | 'aria-invalid'> {
  isChecked?: boolean;
  isReadOnly?: boolean;
  defaultChecked?: boolean;
  icon?: ReactElement;
  spacing?: string | number;
  value?: string | number;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function Checkbox(props: CheckboxProps) {
  return <ChakraCheckbox {...props} />;
}